
import { AlarmScheduleUnitEnum, IAlarmScheduleModel } from "../../services/alarm-schedule-data-service/Models";

const AlarmScheduleAdministrationUtils = {
    getDurationText: (model: IAlarmScheduleModel) : string => {

        switch (model.durationUnit) {
            case AlarmScheduleUnitEnum.Hour:
                return `${model.duration} ${model.duration > 1 ? 'Hours' : 'Hour'}`;

            case AlarmScheduleUnitEnum.Day:
                return `${model.duration} ${model.duration > 1 ? 'Days' : 'Day'}`;

            case AlarmScheduleUnitEnum.Week:
                return `${model.duration} ${model.duration > 1 ? 'Weeks' : 'Week'}`;

            case AlarmScheduleUnitEnum.Month:
                return `${model.duration} ${model.duration > 1 ? 'Months' : 'Month'}`;
            
            case AlarmScheduleUnitEnum.Year:
                return `${model.duration} ${model.duration > 1 ? 'Years' : 'Year'}`;

            default:
                return '';
        }
    },
    getRepeatIntervalText: (model: IAlarmScheduleModel) : string => {

        switch (model.repeatIntervalUnit) {
            case AlarmScheduleUnitEnum.Hour:
                return `${model.repeatInterval} ${model.repeatInterval > 1 ? 'Hours' : 'Hour'}`;

            case AlarmScheduleUnitEnum.Day:
                return `${model.repeatInterval} ${model.repeatInterval > 1 ? 'Days' : 'Day'}`;

            case AlarmScheduleUnitEnum.Week:
                return `${model.repeatInterval} ${model.repeatInterval > 1 ? 'Weeks' : 'Week'}`;

            case AlarmScheduleUnitEnum.Month:
                return `${model.repeatInterval} ${model.repeatInterval > 1 ? 'Months' : 'Month'}`;
            
            case AlarmScheduleUnitEnum.Year:
                return `${model.repeatInterval} ${model.repeatInterval > 1 ? 'Years' : 'Year'}`;

            default:
                return '';
        }
    }
}

export default AlarmScheduleAdministrationUtils;
